import React from 'react';
import sound from "./notification-event-default.wav";
export default sound;